import React from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Grid, useTheme, Theme } from "@mui/material";
import LargeArrowIcon from "icon-large-arrow";
import { sanitizeArrowClassName } from "./sanitizeArrowClassName";
import { StyleProps } from "./types";
import yn from "yn";
import LargeArrowIconV2 from "icons/LargeArrowIconV2";
import { getGlobal } from "@RHCommerceDev/utils/Globals/getGlobal";
import { useLocation } from "react-router-dom";
import Button from "@RHCommerceDev/component-tailwind-button";

const env = getGlobal("_env");
const featureCgCarousel = yn(env.FEATURE_CG_CAROUSEL);
const useStyles = (props: StyleProps) =>
  makeStyles((theme: Theme) => {
    const {
      arrowsSize,
      arrowsVisible = "",
      arrowsBackgroundColor,
      arrowWidth
    } = props;
    const isLarge = arrowsSize === "large";
    const isLargeAem = arrowsSize === "large-AEM";
    const slideArrowWidth = 32;

    return createStyles({
      carouselArrowGrid: {
        opacity: ["never", "hover-only"].includes(arrowsVisible)
          ? "0 !important"
          : "1 !important",
        "&:hover": {
          opacity: arrowsVisible === "never" ? 0 : 1
        }
      },
      carouselArrow: {
        backgroundColor: arrowsBackgroundColor,
        [theme.breakpoints.up("lg")]: {
          width: `${
            arrowWidth
              ? arrowWidth + "px !important"
              : slideArrowWidth + "px !important"
          }`
        }
      }
    });
  });

export const NextArrow = props => {
  const {
    onClick,
    carouselArrowGridStyles,
    carouselArrowStyles,
    className = "",
    allowDisabledClass = false,
    arrowZoomImage,
    imageCarousels,
    arrowsColor,
    icon,
    arrowsBackgroundColor,
    col,
    handleNext = () => {},
    nextArrowAccessibilityProps,
    arrowsSize,
    carouselStatus
  } = props;
  const classes = useStyles(props)();
  const theme = useTheme();

  const conditionalPadding = featureCgCarousel ? "p-0" : "p-[16px]";

  const isLarge = arrowsSize === "large";
  const isLargeAem = arrowsSize === "large-AEM";

  const location = useLocation();
  const isPDP = location.pathname.includes("product/product.jsp");

  return (
    <Grid
      container
      className={`${
        classes.carouselArrowGrid
      } absolute bottom-0 top-0 !w-auto !transition-opacity !duration-500 !ease-in-out ${conditionalPadding} arrow-container z-10 cursor-pointer ${sanitizeArrowClassName(
        className,
        allowDisabledClass
      )}`}
      style={{
        right: imageCarousels ? "-20px" : 0,
        top: imageCarousels ? "-10px" : 0,
        left: arrowZoomImage && "0",
        padding: arrowZoomImage ? "0" : imageCarousels ? "20px 0" : "",
        ...carouselArrowGridStyles,
        transform: arrowZoomImage ? "rotate(90deg)" : "",
        position: arrowZoomImage ? "inherit" : "",
        zIndex: arrowZoomImage ? 0 : "",
        width: "auto !important",
        margin: "0 auto !important",
        opacity: 0.8,
        borderWidth: "0px !important"
      }}
      alignItems="center"
      justifyContent="center"
    >
      <Button
        disableRipple
        className={`p-0 [&:focus-visible]:outline [&:focus-visible]:outline-[1px] [&:focus-visible]:outline-[#015fcc]`}
        onClick={e => {
          e?.preventDefault();

          handleNext();
          onClick && onClick();
        }}
        style={{
          transform: imageCarousels
            ? isPDP
              ? "scale(0.5)"
              : "scale(0.3332)"
            : "",
          cursor: carouselStatus?.atEnd ? "default" : "pointer"
        }}
        {...nextArrowAccessibilityProps}
      >
        {icon == "yes" ? (
          <LargeArrowIconV2
            className={`${classes.carouselArrow} lg:!text-[68px] ${
              isLargeAem ? "!text-[40px]" : "!text-[68px]"
            } ${
              isLargeAem ? "!h-[56px]" : isLarge ? "!h-[68px]" : ""
            } arrow-icon !w-[32px]`}
            style={{
              ...carouselArrowStyles,
              opacity: carouselStatus?.atEnd ? "0.3" : "1",
              transform: "rotate(180deg)",
              backgroundColor: arrowsBackgroundColor || "transparent"
            }}
            fill={arrowsBackgroundColor ? "none" : "white"}
            stroke={arrowsColor ?? theme?.palette?.common?.black}
            data-analytics-id="next"
          />
        ) : (
          <LargeArrowIcon
            className={`${isLargeAem ? "!text-[40px]" : "!text-[68px]"} ${
              isLargeAem || isLarge ? "!h-[56px]" : ""
            } `}
            style={{
              ...carouselArrowStyles,
              transform: "rotate(180deg)",
              backgroundColor: arrowsBackgroundColor || "transparent !important"
            }}
            fill={
              arrowsBackgroundColor ? "none" : isPDP ? "transparent" : "white"
            }
            stroke={arrowsColor ?? theme?.palette?.common?.black}
            data-analytics-id="next"
            col={col}
          />
        )}
      </Button>
    </Grid>
  );
};
export default NextArrow;
